// src/components/Screen5_RankDesign.jsx
import React, { useState, useEffect } from 'react';
import { useAppContext } from '../context/AppContext';
import { fetchCarList, mockApiCarList } from '../api';
import RankCarRow from './RankCarRow';

function Screen5_RankDesign() {
    const { rankingsDesign, updateRankings, showScreen } = useAppContext();
    const [cars, setCars] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    // Note: In a real app, you might pass cars via context, but
    // we follow the original JS logic of fetching on each screen.
    useEffect(() => {
        const loadCars = async () => {
            setIsLoading(true);
            const carList = await fetchCarList('MPV');
            setCars(carList);
            setIsLoading(false);
        };
        loadCars();
    }, []);

    const handleRankClick = (carId) => {
        updateRankings('design', carId);
    };

    // Check completion status
    const totalCars = mockApiCarList.length; // Use mock list for synchronous length check
    const rankedCount = rankingsDesign.length;
    const isComplete = rankedCount === totalCars;

    return (
        <div id="screen-5-design" className="screen screen_padding">
            <h2 className="title_style text-2xl font-semibold text-center mb-2">Which has the best design?</h2>
            <p className="text-sm text-center mb-6 ">(Rank all cars)</p>

            <div id="rank-list-container-design" className="space-y-3 mb-6">
                {isLoading && (
                    <div id="rank-list-loading-design" className="text-center">
                        <i className="fas fa-spinner fa-spin text-2xl"></i>
                        <p>Loading cars...</p>
                    </div>
                )}
                {!isLoading && cars.map(car => {
                    const rank = rankingsDesign.indexOf(car.id) + 1;
                    return (
                        <RankCarRow 
                            key={car.id} 
                            car={car} 
                            rank={rank > 0 ? rank : null}
                            onClick={handleRankClick}
                        />
                    );
                })}
            </div>

            <button 
                id="complete-ranking-btn-design" 
                disabled={!isComplete}
                onClick={() => showScreen('screen-6-interior')}
                className="w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-lg font-medium text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 disabled:bg-gray-400"
            >
                Next
            </button>
            {!isComplete && (
                <p id="complete-ranking-info-design" className="text-center text-sm mt-2">
                    Please rank all {totalCars} cars to continue. ({rankedCount}/{totalCars} ranked)
                </p>
            )}
        </div>
    );
}

export default Screen5_RankDesign;